import { authenticationService } from "../../services/authentication.service";

export function authHeader() {
    // return authorization header with jwt token
    const currentUser = authenticationService.currentUserValue;
    const currentUzivatel = authenticationService.currentUzivatel;
    if (currentUzivatel && currentUser && currentUser.token) {
        return { Authorization: `Bearer ${currentUser.token}` };
    } else {
        return {};
    }
}



// WEBPACK FOOTER //
// ./src/components/common/AuthHeader.js